import { CheckCircle2, RotateCcw, Trash2 } from "lucide-react";

export function TeamDrawActions({ admin, published, onAction }) {
  if (!admin) {
    return null;
  }

  return (
    <div className="team-actions" data-testid="team-admin-actions">
      <button className="button button-secondary" onClick={() => onAction("/matches/current/draw")} data-testid="redraw-teams-button">
        <RotateCcw size={17} />
        Refazer
      </button>
      <button className="button button-primary" onClick={() => onAction("/matches/current/publish")} data-testid="publish-teams-button">
        <CheckCircle2 size={17} />
        {published ? "Republicar" : "Publicar"}
      </button>
      <button className="text-button danger-text" onClick={() => onAction("/matches/current/teams", "delete")} data-testid="clear-teams-button">
        <Trash2 size={16} />
        Limpar times
      </button>
    </div>
  );
}